import axios from "axios";
import { ApiBaseUrl } from "@/constants";
import translateDbField from "@/utils/translateDbField";

export function normalizeTabelaFrontHeaders(rows) {
  return (rows || []).map((header) => {
    const normalized = { ...header };
    normalized.text = translateDbField(normalized.translation_key, normalized.text);
    normalized.show = normalized.show !== false && normalized.show !== 0;
    if (normalized.sortable === undefined && normalized.is_sortable !== undefined) {
      normalized.sortable = !!normalized.is_sortable;
    }
    if (normalized.filtrable === undefined && normalized.is_filtrable !== undefined) {
      normalized.filtrable = !!normalized.is_filtrable;
    }
    if (!normalized.filterType && /^dt_.*_extenso$/.test(normalized.value || '')) {
      normalized.filterType = 'dateRange';
    }
    return normalized;
  });
}

export function mergeTabelaFrontHeadersSession(headers, sessionKey) {
  if (!sessionKey) return headers;
  const saved = sessionStorage.getItem(sessionKey);
  if (!saved) return headers;
  try {
    const parsed = JSON.parse(saved);
    const savedByValue = (parsed || []).reduce((acc, h) => {
      acc[h.value] = h;
      return acc;
    }, {});
    return headers.map((h) => {
      if (savedByValue[h.value] && typeof savedByValue[h.value].show === "boolean") {
        return { ...h, show: savedByValue[h.value].show };
      }
      return h;
    });
  } catch (e) {
    console.log(e);
    return headers;
  }
}

export function persistTabelaFrontHeadersSession(headers, sessionKey) {
  if (!sessionKey || !Array.isArray(headers)) return;
  sessionStorage.setItem(sessionKey, JSON.stringify(headers));
}

export function appendActionsColumn(headers, options = {}) {
  const list = headers || [];
  if (!options.appendActions || list.some((h) => h.value === "actions")) {
    return list;
  }
  const actionsText =
    options.actionsText ||
    (options.translateFn && options.actionsI18nKey
      ? options.translateFn(options.actionsI18nKey)
      : null) ||
    (options.translateFn ? options.translateFn("system.labels.actions") : "Ações");

  return list.concat([
    {
      text: actionsText,
      value: "actions",
      align: null,
      sortable: false,
      filtrable: false,
      show: options.actionsShow !== false,
      to_show: 0,
      to_export: 0,
    },
  ]);
}

export function fetchTabelaFrontHeaders(codTabela, token) {
  const authToken = token || sessionStorage.getItem("api");
  return axios
    .get(`${ApiBaseUrl}/api/v1.0/getheaderstabela/${codTabela}`, {
      headers: { "x-access-token": authToken },
    })
    .then((response) => normalizeTabelaFrontHeaders(response.data || []));
}

export function buildTabelaFrontHeaders(codTabela, token, options = {}) {
  const sessionKey = options.sessionKey || `headers_${codTabela}`;
  return fetchTabelaFrontHeaders(codTabela, token).then((headers) => {
    let result = mergeTabelaFrontHeadersSession(headers, sessionKey);
    result = appendActionsColumn(result, {
      appendActions: options.appendActions,
      actionsText: options.actionsText,
      actionsI18nKey: options.actionsI18nKey,
      actionsShow: options.actionsShow,
      translateFn: options.translateFn,
    });
    persistTabelaFrontHeadersSession(result, sessionKey);
    return result;
  });
}
